module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Ralph_480x480.0e5bceac.mp4";